export default __webpack_public_path__ + "static/media/regreen_visual_01.ffaf26ca.jpg";